<script>
import LayerPersonChooser from '@/layer/components/LayerPersonChooser.vue';
import EggStockTypeQuantityInput from '@/layer/components/EggStockTypeQuantityInput.vue';

export default {
  components: {
    LayerPersonChooser,
    EggStockTypeQuantityInput,
  },

  data: () => ({
    person: '',
    eggStock: [],

    reloadStockTrigger: 0,
  }),

  computed: {
    validationError() {
      if (!this.person) return 'Please choose a Person';
      if (!this.eggStock.find(x => x.quantity > 0)) return 'Please fill in at least one of the Types';

      return undefined;
    },

    submitPayload() {
      let quantityPerTypeId = {};
      this.eggStock.filter(x => x.quantity > 0).forEach(x => { quantityPerTypeId[x.type.id] = x.quantity });

      return {
        person: this.person,
        types: quantityPerTypeId,
      };
    },
  },

  methods: {
    clearForm() {
      this.person = '';
    },

    onFormSubmitSuccess(payload) {
      this.clearForm();
      this.eggStock = [];
      this.reloadStockTrigger++;
    },

    onCancelledForm() {
      this.$router.push({ name: 'form-cancelled' });
    },
  },
}
</script>

<template>

  <b-card>
    <api-form
      method="post"
      url="v1/layers/do-stock-count"
      :payload="submitPayload"
      submit-text="Save Stock Counts"
      :validation-error="validationError"
      :make-success-message="() => `Stock Count was successfully saved.`"
      @success="onFormSubmitSuccess"
      @cancel="onCancelledForm">

      <slot name="above-header"></slot>

      <h4 class="text-center mt-0">Count Stock</h4>

      <layer-person-chooser v-model="person" required />

      <div v-if="person">
        <b-form-group v-if="eggStock">
          <api-loader
            :key="reloadStockTrigger"
            method="get"
            url="v1/layers/egg-stock"
            @loaded="eggStock=$event" />

          <div v-for="item in eggStock" :key="item.type.id" class="mt-4">
            <egg-stock-type-quantity-input
              v-model="item.quantity"
              :type-name="item.type.type"
              :unit="item.type.unit"
              :quantity-per-box="item.type.quantity_per_box" />
          </div>

        </b-form-group>
      </div>

    </api-form>

  </b-card>
</template>



// WEBPACK FOOTER //
// src/layer/components/EggStockCount.vue